<template>
  <div class="login-wrap">
    <div class="login-container">
      <div class="login-side">
        <div class="login-img"></div>
      </div>
      <div class="login-ID">
        <div class="login-title">
          <h3>用户登录</h3>
        </div>
        <el-form label-position="top">
          <el-form-item>
            <el-input placeholder="用户名" v-model="loginForm.account" clearable >
              <template #prefix>
                <i class="jk-icon jk-icon-yonghu"></i>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item >
            <el-input placeholder="密码" show-password
                      type="password" v-model="loginForm.password">
              <template #prefix>
                <i class="jk-icon jk-icon-mima"></i>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item class="check-item">
            <el-alert v-if="isCheck" title="验证成功" type="success" show-icon :closable="false"/>
            <el-alert v-else :class="[loginForm.password && loginForm.account ? '' : 'not-click']" title="点击按钮进行验证" type="info" show-icon :closable="false" @click="isCheck = true">
              <template #icon>
                <i class="jk-icon jk-icon-xuanzhong"></i>
              </template>
            </el-alert>
          </el-form-item>
          <el-form-item>
            <el-button class="block-button" type="primary" :loading="loading" :disabled="!isCheck" :auto-insert-space="true" @click="loginSubmit">登录</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeLogin"
}
</script>
<script setup>
import {login} from "@/api/index";
import {useUserStore} from "@/store/module/user";
import {useRouter} from "vue-router";
import {reactive, ref, watch} from "vue";
import {ElMessage} from "element-plus";
import {throttle} from "lodash-es";

const router = useRouter()
const userStore = useUserStore()
const loading = ref(false);
const isCheck = ref(false);
const loginForm = reactive({
  account: '',
  password: '',
})
watch(() => loginForm,throttle((newVal, oldVal)=>{
  isCheck.value = false;
},1000),{deep:true})
const loginSubmit = async () => {
  loading.value = true;
  login(loginForm.account, loginForm.password).then((res)=>{
    return loginSuccess(res)
  }).finally(() => {
    loading.value = false;
  })

}
const loginSuccess = async ({data,message}) => {
  ElMessage.success(message)
  userStore.token = data.token
  await userStore.loadMenus()
  await userStore.loadAuthRule()
  router.push('/')
}
</script>

<style scoped>
.login-wrap {
  width: 100%;
  overflow: auto;
  min-width: 600px;
  z-index: 9;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background:var(--el-color-primary-light-9);
}
.login-container {
  position: relative;
  overflow: hidden;
  width: calc(100% - 28px);
  height: 540px;
  max-width: 1000px;
  background: #1890FF;  /* fallback for old browsers */
  display: flex;
  box-shadow: 6px 6px 12px 4px rgba(0, 0, 0, 0.1);
  border-radius:5px;
}

.login-side {
  display:inline-flex;
  flex: 1;
  height:100%;
  padding:60px 40px;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  box-sizing: border-box;
}
.login-logo{
  width:100%;
  font-size:24px;
  font-weight: bold;
  color:#fff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.login-logo img{
  width:45px;
  height:45px;
}
.login-img{
  width:100%;
  flex: 1;
  background:url("../../assets/images/login-img.png") bottom no-repeat; /* 波浪线的颜色 */
  background-size: 100% auto;
}

.login-ID {
  padding:80px 60px 80px 65px;
  box-sizing: border-box;
  width:50%;
  position: relative;
  background: var(--el-bg-color);
}
.login-title{
  font-size: var(--el-font-size-large);
  margin-bottom:40px;
  text-align: center;
}
.login-title div {
  color: var(--el-text-color-secondary);
  font-weight: normal;
}
.check-item :deep(.el-alert){
  cursor: pointer;
  border-radius: var(--el-input-border-radius,var(--el-border-radius-base));
  border: 1px solid var(--el-border-color);
}
.check-item :deep(.el-alert--success){
  border-color: var(--el-border-color-success);
}
</style>
